import { Dispatch, ReactChild, SetStateAction, createContext } from 'react'

import type { EmblaCarouselType } from 'embla-carousel'

import { CarouselOrListingBlockProps } from '.'

export type CarouselOrListingBlockType = {
  embla: EmblaCarouselType | null
  setEmbla: Dispatch<SetStateAction<EmblaCarouselType | null>>
  showFullSlide?: boolean
  filteredChild: ReactChild[]
  setFilteredChild: Dispatch<SetStateAction<ReactChild[]>>
} & Omit<CarouselOrListingBlockProps, 'children'>

export const CarouselOrListingBlockContext = createContext<CarouselOrListingBlockType>(
  {} as CarouselOrListingBlockType,
)
